import { constants, typographyStyles } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";

const { colors } = constants;
const { textMObj } = typographyStyles;

const green500 = colors.ui.green[500];
const greenWithOpacity = `${green500}}26`;
const neutral50 = colors.ui.neutral[50];
const neutral500 = colors.ui.neutral[500];

const COLOR_GREEN_CORRECT_ANSWER = (isBorderColor: boolean) =>
  isBorderColor ? "" : greenWithOpacity;
const COLOR_GREY_NOT_ANSWERED = colors.ui.neutral[25];
const COLOR_GREY_WRONG_ANSWER = "#EAEBEC";

const renderColorByStatus = ({
  isSubmitted = false,
  userSelectedCorrectChoice = false,
  userHasSelectedQuestion = false,
  isBorderColor = false,
}) =>
  isSubmitted
    ? !userSelectedCorrectChoice
      ? userHasSelectedQuestion
        ? COLOR_GREY_WRONG_ANSWER
        : COLOR_GREY_NOT_ANSWERED
      : COLOR_GREEN_CORRECT_ANSWER(isBorderColor)
    : COLOR_GREY_NOT_ANSWERED;

export const containerCss: CSSObject = {
  marginBottom: "24px",
};

export const multipleChoiceContainerCss = (
  questionAnswerStatus: {
    userSelectedCorrectChoice: boolean;
    isSubmitted: boolean;
    userHasSelectedQuestion: boolean;
  },
  isReadAloudButtonActive: boolean,
) => ({
  backgroundColor: renderColorByStatus(questionAnswerStatus),
  border: `2px solid ${renderColorByStatus({ ...questionAnswerStatus, isBorderColor: true })}`,
  borderRadius: isReadAloudButtonActive ? "4px 4px 0px 0px" : "4px",
  display: "block",
  width: "100%",

  ":hover": {
    ...(questionAnswerStatus.isSubmitted
      ? {
          backgroundColor: neutral50,
        }
      : {}),
    cursor: "pointer",
  },

  "input:focus-visible + div": {
    backgroundColor: neutral50,
    border: `2px solid ${colors.ui.core[500]}`,
  },
});

export const multipleChoiceCss: CSSObject = {
  display: "flex",
  position: "relative",
  alignItems: "center",
  color: neutral500,
  padding: "12px 16px",
};

export const choiceLetterCss: CSSObject = {
  ...textMObj,
  fontWeight: "bold",
  marginRight: "16px",
};

export const choiceTextCss: CSSObject = {
  ...textMObj,
  whiteSpace: "pre-line",

  p: {
    margin: 0,
  },
};

export const inputCss: CSSObject = {
  display: "inherit",
  appearance: "none",
  margin: 0,
  padding: 0,
};

export const interactiveMultipleChoiceLabelCss: CSSObject = {
  position: "absolute",
  top: "-10px",
  left: "42px",
};
